/**
    This file is autogenerated using the command `yarn app-store:build --watch`.
    Don't modify this file manually.
**/
import campfire_config_json from "./campfire/config.json";
import { metadata as dailyvideo__metadata_ts } from "./dailyvideo/_metadata";
import databuddy_config_json from "./databuddy/config.json";
import demodesk_config_json from "./demodesk/config.json";
import dialpad_config_json from "./dialpad/config.json";
import discord_config_json from "./discord/config.json";
import eightxeight_config_json from "./eightxeight/config.json";
import element_call_config_json from "./element-call/config.json";
import facetime_config_json from "./facetime/config.json";
import fathom_config_json from "./fathom/config.json";
import ga4_config_json from "./ga4/config.json";
import { metadata as googlevideo__metadata_ts } from "./googlevideo/_metadata";
import gtm_config_json from "./gtm/config.json";
import horizon_workrooms_config_json from "./horizon-workrooms/config.json";
import { metadata as huddle01video__metadata_ts } from "./huddle01video/_metadata";
import insihts_config_json from "./insihts/config.json";
import jelly_config_json from "./jelly/config.json";
import { metadata as jitsivideo__metadata_ts } from "./jitsivideo/_metadata";
import matomo_config_json from "./matomo/config.json";
import metapixel_config_json from "./metapixel/config.json";
import mirotalk_config_json from "./mirotalk/config.json";
import nextcloudtalk_config_json from "./nextcloudtalk/config.json";
import office365video_config_json from "./office365video/config.json";
import ping_config_json from "./ping/config.json";
import plausible_config_json from "./plausible/config.json";
import posthog_config_json from "./posthog/config.json";
import riverside_config_json from "./riverside/config.json";
import roam_config_json from "./roam/config.json";
import salesroom_config_json from "./salesroom/config.json";
import shimmervideo_config_json from "./shimmervideo/config.json";
import signal_config_json from "./signal/config.json";
import sirius_video_config_json from "./sirius_video/config.json";
import skype_config_json from "./skype/config.json";
import sylapsvideo_config_json from "./sylapsvideo/config.json";
import { metadata as tandemvideo__metadata_ts } from "./tandemvideo/_metadata";
import telegram_config_json from "./telegram/config.json";
import booking_pages_tag_config_json from "./templates/booking-pages-tag/config.json";
import event_type_location_video_static_config_json from "./templates/event-type-location-video-static/config.json";
import twipla_config_json from "./twipla/config.json";
import umami_config_json from "./umami/config.json";
import webex_config_json from "./webex/config.json";
import whatsapp_config_json from "./whatsapp/config.json";
import whereby_config_json from "./whereby/config.json";
import { metadata as zoomvideo__metadata_ts } from "./zoomvideo/_metadata";
export const appStoreMetadata = {
	campfire: campfire_config_json,
	dailyvideo: dailyvideo__metadata_ts,
	databuddy: databuddy_config_json,
	demodesk: demodesk_config_json,
	dialpad: dialpad_config_json,
	discord: discord_config_json,
	eightxeight: eightxeight_config_json,
	"element-call": element_call_config_json,
	facetime: facetime_config_json,
	fathom: fathom_config_json,
	ga4: ga4_config_json,
	googlevideo: googlevideo__metadata_ts,
	gtm: gtm_config_json,
	"horizon-workrooms": horizon_workrooms_config_json,
	huddle01video: huddle01video__metadata_ts,
	insihts: insihts_config_json,
	jelly: jelly_config_json,
	jitsivideo: jitsivideo__metadata_ts,
	matomo: matomo_config_json,
	metapixel: metapixel_config_json,
	mirotalk: mirotalk_config_json,
	nextcloudtalk: nextcloudtalk_config_json,
	office365video: office365video_config_json,
	ping: ping_config_json,
	plausible: plausible_config_json,
	posthog: posthog_config_json,
	riverside: riverside_config_json,
	roam: roam_config_json,
	salesroom: salesroom_config_json,
	shimmervideo: shimmervideo_config_json,
	signal: signal_config_json,
	sirius_video: sirius_video_config_json,
	skype: skype_config_json,
	sylapsvideo: sylapsvideo_config_json,
	tandemvideo: tandemvideo__metadata_ts,
	telegram: telegram_config_json,
	"booking-pages-tag": booking_pages_tag_config_json,
	"event-type-location-video-static":
		event_type_location_video_static_config_json,
	twipla: twipla_config_json,
	umami: umami_config_json,
	webex: webex_config_json,
	whatsapp: whatsapp_config_json,
	whereby: whereby_config_json,
	zoomvideo: zoomvideo__metadata_ts,
};
